import MessageBubbleChatbot from './messageBubbleChatbot.jsx';

export default function MessageChatbot({modeChatbot,welcomeNavigationStateChatbot, item, index, isFirstMessage, isLastMessage}) {
	return (
		<MessageBubbleChatbot
			modeChatbot={modeChatbot}
			welcomeNavigationStateChatbot={welcomeNavigationStateChatbot}
			item={item}
			isFirstMessage={isFirstMessage(item, index)}
			isLastMessage={isLastMessage(item, index)}
			transform={transform}
		/>
	);
}

function transform(markup) {
	const boldTitleRegex = /(\d+\.\s)\*\*([a-zA-ZáéíóúÁÉÍÓÚñÑ0-9\s\-–()+!¡%&\.]*)\*\*(:|\n)/g; // Regular expression for bold text
	const boldRegex = /\*\*([a-zA-ZáéíóúÁÉÍÓÚñÑ0-1-9\s:()!¡%&\.]*)\*\*/g; // Regular expression for bold text
	const lineBreakRegex = /\n/g; // Regular expression for line breaks
	const bracketLinkRegex = /\[([^\]]+)\](\s+)?\((https?:\/\/[^\s)]+)\)/g; // Regular expression for links in [texto](url) format
	// TODO: support safari iphone 13 with 15 iOS
	const titleTextRegex = /((?<=>\s*)(#+\s?.+?)(?=<|$))|(^#+\s?.+?)(?=<|$)/gm; //Regular expression for titles
	const listLiRegex = /(?<!<span\sclass="[a-z-]+">[0-9A-Za-z\s\.]+)(?<=>)\s*?-\s(.+?)(?=\n|<br\s*\/?>|$)/gm; //Regular expressions to detect the start of an item to replace it with <li>
	
	function filterSharps(text) {
		const matches = [...text.matchAll(titleTextRegex)];
		const results = matches.map(match => match[0]); // Get the full matches, not just the capture group
		let regex = /^#+/; // Regular expression to find the number of #

		let labels = results.map((match) => {
			let sharpsMatch = match.match(regex);
			if (sharpsMatch) {
				let sharpCount = sharpsMatch[0].length; // Count the number of #
				let text = match.replace(regex, "").trim(); // Remove the # and trim spaces
				return `<h${sharpCount} style="display:inline; font-weight: bold; font-size: 2vh;">${text}</h${sharpCount}>`;
			}
		});
		// Replace each found title with its corresponding tag
		let transformedText = text;
		results.forEach((result, index) => {
			transformedText = transformedText.replace(result, labels[index]);
		});
		return transformedText;
	}

	function filterUl(text) {
		const listUlRegex = /<li(?: style="list-style:disc; list-style-position: inside;")?(?![^<]*<h3[^>]*>)(.*?)<\/li>(?:<br\/>(?:\s*)<br\/>|$)/gs;
		const matches = [...text.matchAll(listUlRegex)];
		const results = matches.map(match => match[0]); // Get the full matches

		// Wrap each match with <ul>
		const wrappedResults = results.map(match => `<ul style="line-height: 1.2; margin: 0; padding-inline-start: 10px;">${match}</ul>`);

		// Replace each match in the original text with the version wrapped in <ul>
		let transformedText = text;
		results.forEach((match, i) => {
			transformedText = transformedText.replace(match, wrappedResults[i]);
		});

		return transformedText;
	}

	// Apply the markup according to the regular expressions
	markup = markup.replace(boldTitleRegex, '$1<span class="bot-utn-bold-text">$2$3</span>');
	markup = markup.replace(boldRegex, '<span class="bot-utn-bold-text">$1</span>');
	markup = markup.replace(lineBreakRegex, '<br/>');
	markup = markup.replace(bracketLinkRegex, '<a class="bot-utn-routerlink" href="$3" target="_blank">$1</a>');
	markup = markup.replace(listLiRegex, '<li style="list-style:disc; list-style-position: inside;">$1</li>');
	markup = markup.replace(markup, filterSharps(markup));
	markup = markup.replace(markup, filterUl(markup));
	return { __html: markup };
}

